import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";
import { Noimage } from "../../common/imagePath";
import moment from "moment";
import HistoryIcon from "@mui/icons-material/History";
import { toastError, toastSuccess } from "../../common/Toast";
import { Email } from "@material-ui/icons";
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import { ERROR_MESSAGE } from "../../common/Constant";
import AddressModal from "./AddressModal";
import { AppContext } from "../../context/AppContext";
import CurrencySymbols from "../../common/CurrencySymbol";
import loadingimage from "../../assets/img/loading-svg.svg";

const CustomerSupplierDetailModel = ({ id, model, show, handleClose }) => {
  const Id = localStorage.getItem("ID");
  const [historyData, setHistoryData] = useState([]);
  const { CurrencySymbol, FractionDigits, dateFormate } = useContext(AppContext);
  const [details, setDetails] = useState({});
  const [loginDetails, setLoginDetails] = useState([]);
  const [customerAddressBookList, setcustomerAddressBookList] = useState([]);
  const [dataSaleList, setDataSaleList] = useState([]);
  const [dataReceivePaymentList, setDataReceivePaymentList] = useState([]);
  const [dataReceiveList, setDataReceiveList] = useState([]);
  const [dataPayBillList, setDataPayBillList] = useState([]);
  const [dataEmployeeList, setDataEmployeeList] = useState([]);
  const [isecom, setisecom] = useState(false);
  const [passworddeable, setpassworddeable] = useState(0);
  const [isPasswordChanged, setIsPasswordChanged] = useState(0);
  const [changePassword, setChnagePassword] = useState(false);
  const [eyeNew, seteyeNew] = useState(true);
  const [eyePass, seteyePass] = useState(true);
  const [eyeConfirm, setConfirmeye] = useState(true);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [usernamePass, setUsernamePass] = useState({
    Uname: "",
    Pass: "",
    ConfirmPass: "",
    OriginalPassword: null,
    Email: "",
  });
  const [AddressEdit, setAddressEdit] = useState({
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    ID: 0,
    ShippingDefault: 0,
  });
  const [open, setOpen] = useState(false);

  const [fulladdress, setfulladdress] = useState([]);

  
 const [balanceLading, setBalanceLoading] = useState(false);
  const [showCustomerBalance, setShowCustomerBalance] = useState(false);
  const [customerBalance, setCustomerBalance] = useState(false);

  console.log(customerAddressBookList, "customerAddressBookList");
  const navigate = useNavigate();
  let PERMISSION_EDIT = "/manage-customers/:id";
  let PERMISSION_PASSWORD = "manage-customer-password";
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const LoginId = localStorage.getItem("ID");

  console.log(model, "check model");

  const edithandel = (e) => {
    // navigate(`/manage-Items/${itemsDetailsData?.ItemInfo[0]?.ID}`);
  };

  // console.log(dataReceiveList, "dataReceiveList");
  // console.log(dataPayBillList, "dataReceiveList");
  // console.log(dataEmployeeList, "dataEmployeeList");

  const Clone = (id) => {
    localStorage.setItem("Clone", id);
    window.location.reload();
  };

  // const userNameChange = (e) => {
  //   setUsernamePass({ ...usernamePass, Uname: e.target.value });
  // };

  const emailChange = (e) => {
    setUsernamePass({ ...usernamePass, Email: e.target.value });
  };

  const handleDeleteAddress = (addressdata) => {
    let payload = {
      id: addressdata.ID,
      loginuserid: Number(Id),
      customerid: addressdata.CustomerID,
    };

    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/customershippingaddressdelete`,
        payload,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (
          res.data.ResponseCode === "SUCCESS" &&
          res.data.ResponseData[0].ID > 0
        ) {
          toastSuccess("Shipping Address Deleted Successfully");
          getShippingAddressByCustomerId();
          // handleClose();
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleSendEmail = (Uname, Pass, ConfirmPass, Email) => {
    if (usernamePass.ConfirmPass !== "") {
      let passwordUpdate = {
        id: LoginId,
        Customerid: id,
        newpassword: Pass ? Pass : usernamePass.OriginalPassword,
        systempass: Pass ? Pass : usernamePass.OriginalPassword,
        userName: Uname,
        // isEcom: isecom ? 1 : 0,
        isEcom: 2,
        Email: Email,
      };

      if (Pass != ConfirmPass) {
        toastError("New Password and Confirm Password must be same");
        return;
      }

      axios
        .post(
          `${config.customersBaseUrl}/customers/changepassword`,
          passwordUpdate,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(res.data.ResponseMessage);
            setLoading(false);
            setChnagePassword(false);
            setUsernamePass({
              ...usernamePass,
              Uname: Uname,
              OriginalPassword: Pass ? Pass : usernamePass.OriginalPassword,
              Pass: "",
              ConfirmPass: "",
            });
            // Pass: "", ConfirmPass: "",
            seteyeNew(true);
            seteyePass(true);
            setConfirmeye(true);
          } else if (res.data.ResponseCode === "ERROR") {
            toastError(res.data.ResponseMessage);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    if (
      usernamePass?.OriginalPassword == "Password Changed" &&
      usernamePass.ConfirmPass === ""
    ) {
      toastError("Password Changed!");
      return;
    }
    axios
      .get(`${config.customersBaseUrl}/customers/ResendEcomPassword?id=${id}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(res.data.ResponseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const passwordChange = (e) => {
  //   setUsernamePass({ ...usernamePass, Pass: e.target.value });
  // };

  const onEyeNewClick = () => {
    seteyeNew(!eyeNew);
  };

  const onEyeConfirmClick = () => {
    setConfirmeye(!eyeConfirm);
  };

  const onEyePassClick = () => {
    seteyePass(!eyePass);
  };

  const getShippingAddressByCustomerId = () => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/ShiipingAdresssbyID?CustomerID=${id}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res, "res.data.ResponseData516516501");
        setcustomerAddressBookList(res.data.ResponseData);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (id > 0) {
      if (model === "customer") {
        getShippingAddressByCustomerId();
      }
    }
  }, [id, open]);

  useEffect(() => {
    if (id > 0 && show) {
      if (model === "customer") {
        // axios
        //   .get(
        //     `${config.salesconfigBaseUrl}/sales/saleslist?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&status=0&enddate=&salestypeid=0&customerid=0&LocationID=${location}&isShowEcomOrders=1&SalePaymentStatus=0&loginId=${LoginId}`,
        //     {
        //       headers: {
        //         "Content-Type": "application/json;charset=UTF-8",
        //         Authorization: token,
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     setHistoryData(res.data.ResponseData?.list);

        //     // setLoading(false);
        //   })
        //   .catch((err) => {
        //     // setLoading(false);
        //   });

        axios
          .get(
            `${config.customersBaseUrl}/customers/customertransactionlist?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagesize=20&pagenumber=1&filtertext=&startdate=&salestypeid=8&customerid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            const ListData = res.data.ResponseData;

            const filterSaleData = ListData?.filter(
              (el) => el?.SaleType === "Sale"
            );
            console.log(ListData, "ListData");
            // console.log(filterSaleData, "ListData")
            setDataSaleList(filterSaleData);
            // setLoading(false);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(
            `${config.customersBaseUrl}/customers/customertransactionlist?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagesize=20&pagenumber=1&filtertext=&startdate=&salestypeid=11&customerid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            const ListData = res.data.ResponseData;

            const filterPaymentData = ListData?.filter(
              (el) => el?.SaleType === "Receive Payment"
            );
            // console.log(ListData, "ListData")
            // console.log(filterSaleData, "ListData")
            setDataReceivePaymentList(filterPaymentData);
            // setLoading(false);
          })
          .catch((err) => {
            // setLoading(false);
          })



        axios
          .get(`${config.customersBaseUrl}/customers/findbyid?id=${id}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            const customerdata = res.data.ResponseData.CustomerDetails[0];
            // setDetails(res.data.ResponseData?.CustomerDetails[0]);
            setDetails(customerdata);
            setisecom(customerdata.IsEcommerceUser === 1 ? true : false);
            setpassworddeable(customerdata.IsEcommerceUser);
            setIsPasswordChanged(customerdata.IsPasswordChanged);
            setUsernamePass({
              Uname: customerdata?.UserLogin,
              Pass: "",
              ConfirmPass: "",
              OriginalPassword: customerdata.OriginalPassword,
              Email: customerdata.Email,
            });
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(
            `${config.customersBaseUrl}/customers/EcomUserLoginHistoryById?CustomerId=${id}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            const loginData = res.data.ResponseData;
            setLoginDetails(loginData);
          })
          .catch((err) => {
            // setLoading(false);
          });

      } else if (model === "supplier") {
        // axios
        //   .get(
        //     `${config.receivingBaseUrl}/receivings/listofalldata?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&enddate=&receivingtypeid=0&supplierid=0&status=0&LocationID=${location}&receivePaymentStatus=0&loginId=${LoginId}`,
        //     {
        //       headers: {
        //         "Content-Type": "application/json;charset=UTF-8",
        //         Authorization: token,
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     console.log("listofsuspendrecord", res.data.ResponseData?.list);
        //     setHistoryData(res.data.ResponseData?.list);
        //   })
        //   .catch((err) => {
        //     // setLoading(false);
        //   });

        axios
          .get(
            `${config.receivingBaseUrl}/receivings/transactionlistsupplier?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagesize=20&pagenumber=1&filtertext=&startdate=&enddate=&receivetypeid=3&supplierid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterReceiveData = ListData?.filter(
              (el) => el?.ReceivingType === "Receive"
            );
            // console.log(ListData, "ListData")
            // console.log(filterReceiveData, "ListData")
            setDataReceiveList(filterReceiveData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(
            `${config.receivingBaseUrl}/receivings/transactionlistsupplier?filtercolumnsearchtext=&currentorder=desc&ordercolumn=&pagesize=20&pagenumber=1&filtertext=&startdate=&enddate=&receivetypeid=7&supplierid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterPayBillData = ListData?.filter(
              (el) => el?.ReceivingType === "Bill Payment"
            );
            // console.log(ListData, "ListData")
            // console.log(filterPayBillData, "ListData")
            setDataPayBillList(filterPayBillData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(`${config.suppliersBaseUrl}/suppliers/findbyid?id=${id}&locationid=${location}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            const data = res.data.ResponseData?.Items[0];
            // console.log(data, "supplierdata215");
            setDetails({
              ...data,
              StateProvince: data?.State,
              InternalNotes: data?.Internalnotes,
              AccountNumber: data?.Accountnumber,
              Id: data?.ID,
            });
          })
          .catch((err) => {
            // setLoading(false);
          });
      } else {
        axios
          .get(
            `${config.accountingBaseUrl}/chartofaccounts/getexpenselist?startdate=&enddate=&payeetype=2&locationid=${location}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterReceiveData = ListData?.filter(
              (el) => el?.payee === "employee"
            );
            // console.log(ListData, "ListData")
            // console.log(filterReceiveData, "ListData")
            setDataEmployeeList(filterReceiveData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(`${config.employeesBaseUrl}/employees/findbyid?id=${id}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            const data = res.data.ResponseData.EmployeeDetails[0];
            // console.log(data, "employeeData");
            setDetails({
              ...data,
              StateProvince: data?.State,
              EmployeeRole: data?.EmployeeRoleName,
              PhoneNumber: data?.Phonenumber,
              LastName: data?.Lastname,
              FirstName: data?.Firstname,
              Id: data?.Id,
            });
          });
      }
    }
  }, [id, open, show]);

  const handleSubmit = (Uname, Pass, ConfirmPass, Email) => {
    setLoading(true);
    let passwordUpdate = {
      id: LoginId,
      Customerid: id,
      newpassword: Pass ? Pass : usernamePass.OriginalPassword,
      systempass: Pass ? Pass : usernamePass.OriginalPassword,
      userName: Uname,
      // isEcom: isecom ? 1 : 0,
      isEcom: 2,
      Email: Email,
    };

    if (Pass != ConfirmPass) {
      toastError("New Password and Confirm Password must be same");
      return;
    }

    axios
      .post(
        `${config.customersBaseUrl}/customers/changepassword`,
        passwordUpdate,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage);
          setLoading(false);
          setChnagePassword(false);
          setUsernamePass({
            ...usernamePass,
            Uname: Uname,
            OriginalPassword: Pass ? Pass : usernamePass.OriginalPassword,
          });
          // Pass: "", ConfirmPass: "",
          seteyeNew(true);
          seteyePass(true);
          setConfirmeye(true);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(res.data.ResponseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleEcomNavigate = (CustomerData) => {
    console.log("id ==> 122112221212", CustomerData);

    // Correctly create the Data object
    const Data = {
      customerId: CustomerData.Id,
      Role: CustomerData.RoleTierName,
      Username: CustomerData.Username,
      Token: "",
      ProfilePic: CustomerData.ProfilePic ? CustomerData.ProfilePic : "",
      EmailId: CustomerData.Email,
      CompanyName: CustomerData.CompanyName,
      isLoggedIn: true,
      IsPasswordChanged: CustomerData.IsPasswordChanged,
      LoginCount: CustomerData.LoginCount,
      RoleId: CustomerData.RoleTierID,
      DisplayQuantityEComm: CustomerData.DisplayQuantityEComm,
      AllowResell: CustomerData.AllowResell,
      c: "sonarpos",
      EmployeeName: localStorage.getItem("Name"),
    };

    // Convert Data to Base64 encoded string
    let id = btoa(JSON.stringify(Data));
    console.log("id ==> 122112221212", id);

    // Redirect to the URL with the encrypted data
    // window.location.href = `${ecommWebsiteUrl}/account/shopping-cart?e=${id}`;
    // window.open(`http://localhost:3000/account/shopping-cart?e=${id}`);
    window.open(
      `${config.ecommWebsiteUrl}/account/shopping-cart?e=${id}`,
      "_blank"
    );
  };

  const handleclicks = () => {
    setOpen(true);
    setAddressEdit({
      Address1: "",
      Address2: "",
      City: "",
      StateProvince: "",
      Zip: "",
      Country: "",
      ID: 0,
      ShippingDefault: 0,
    });
  };

  const yesID =
    customerAddressBookList.find((item) => item.ShippingDefault > 0)?.ID ??
    customerAddressBookList.find((item) => item.LastSaleAddressID == item.ID)
      ?.ID ??
    customerAddressBookList.find((item) => item.IsDefault == 1)?.ID ??
    null;

    const handlePaymentClick = (payment) => {
    let baseUrl = "";
    if (model === "customer") {
      baseUrl = "receive-payment";
    } else if (model === "supplier") {
      baseUrl = "receiving-paybills";
    }
    navigate(`/${baseUrl}/${payment}`);
  };


    const getCustomerBalanceById = (custID) => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerbalancebyid?id=${custID}&location=${location}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(
          res?.data?.ResponseData[0]?.OpenBalance,
          "customer balance data"
        );
        const customerBalance =
          res?.data?.ResponseData[0]?.OpenBalance || 0;
        setCustomerBalance(customerBalance);
        setBalanceLoading(false);
      })
      .catch((err) => {
        setBalanceLoading(false);
      });
  };

    const callSupplierGetApi = (ID) => {
      axios
        .get(
          `${config.suppliersBaseUrl}/suppliers/supplierbalancebyid?id=${ID}&location=${location}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
           if (
                    response.data.ResponseData?.length > 0
                  ) {
                    let supplierData = response.data.ResponseData[0];
                    setCustomerBalance(supplierData.OpenBalance);
                    setBalanceLoading(false);
                  }
        })
        .catch((error) => {
          setBalanceLoading(false);
          console.log(error);
        });
    };

  const checkBalance = (id)=> {
    setShowCustomerBalance(true);
    setBalanceLoading(true)
    if(model === "customer"){
      getCustomerBalanceById(id);
    }else if(model != "employee"){
      callSupplierGetApi(id);
    }
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        fullscreen
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title>Recent Transaction Log</Modal.Title>

          <div className="d-flex gap-2">
            {checkUserPermission("/login-as-customer") &&
              model === "customer" && (
                <Button
                  style={{
                    backgroundColor: "#1a2649",
                    color: "white",
                    borderRadius: "8px",
                  }}
                  onClick={() => handleEcomNavigate(details)}
                  className="fs-8"
                >
                  Login as Customer
                </Button>
              )}
            <Button variant="secondary" onClick={() => handleClose()}>
              ×
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Tabs
            id="customer-supplier-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab
              eventKey="tab1"
              title={
                model === "customer"
                  ? "Sales"
                  : model === "supplier"
                  ? "Receive"
                  : "Employee Recent"
              }
            >
              <div className="row">
                <div className="col-md-12 p-3">
                  <div className="table-responsive">
                    <table className="table mb-0 table-border ">
                      <thead>
                        <tr>
                          {/* <th>{model === "customer" ? 'Sale Id' : model === "supplier" ? 'Receiving Id': 'Employee'}</th> */}
                          <th>Date</th>
                          {model !== "employee" && (
                            <>
                              <th>
                                {model === "customer"
                                  ? "Invoice No."
                                  : model === "supplier"
                                  ? "Bill No."
                                  : "Employee"}
                              </th>
                              <th>Qty</th>
                            </>
                          )}
                          <th>Amount</th>
                          {/* <th>Clone</th> */}
                          {model === "customer" && <th>Address</th>}
                          <th>Receipt</th>
                          <th>Comment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(model === "customer"
                          ? dataSaleList
                          : model === "supplier"
                          ? dataReceiveList
                          : dataEmployeeList
                        )?.map((items, index) => {
                          return (
                            <tr key={index}>
                              {/* <td className="col-md-3">{items?.ID}</td> */}
                              <td className="col-md-3">
                                {moment(
                                  model === "employee"
                                    ? items?.ReceivingTime
                                    : items?.Date // LatestDate
                                )?.format(`${dateFormate.toUpperCase()}`)}
                              </td>
                              {model !== "employee" && (
                                <>
                                  <td className="col-md-3">
                                    {model === "customer"
                                      ? items?.InvoiceNo
                                      : model === "supplier"
                                      ? items?.BillNo
                                      : ""}
                                  </td>
                                  <td className="col-md-3">{items?.Qty}</td>
                                </>
                              )}
                              <td className="col-md-3">
                                {model === "employee"
                                 ? CurrencySymbols(
                                              Number(items?.Total),
                                              { CurrencySymbol },
                                              FractionDigits
                                            )
                                  : CurrencySymbols(
                                      Number(items?.Payment), 
                                      { CurrencySymbol },
                                      FractionDigits
                                    )

                                  // ? `$${Number(items?.Total).toLocaleString(
                                  //     "en-US",
                                  //     {
                                  //       minimumFractionDigits: 2,
                                  //       maximumFractionDigits: 2,
                                  //     }
                                  //   )}`
                                  // : `$${Number(items?.Payment).toLocaleString(
                                  //     "en-US",
                                  //     {
                                  //       minimumFractionDigits: 2,
                                  //       maximumFractionDigits: 2,
                                  //     }
                                  //   )}`
                                    }
                              </td>
                              {/* <td
                                        className="col-md-3"
                                        onClick={() => Clone(items?.ID)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Clone
                                      </td> */}

                              {model === "customer" && (
                                <td className="col-md-3">
                                  {items?.ShipBillAddress}
                                </td>
                              )}
                              <td
                                className="col-md-3"
                                // onClick={() =>{
                                //   if(model === "customer"){
                                //     navigate(`/sales-receipt/${items?.InvoiceNo}`)
                                //   }else if(model === "supplier"){
                                //     navigate(`/receiving-receipt/${items?.ID}`)
                                //   }else{
                                //     navigate(`/sales-receipt/${items?.InvoiceNo}`)
                                //   }}
                                // }
                                // style={{ cursor: "pointer" }}
                              >
                                <Link
                                  to={
                                    model === "customer"
                                      ? `/sales-receipt/${items?.InvoiceNo}`
                                      : model === "supplier"
                                      ? `/receiving-receipt/${items?.ID}`
                                      : `/receiving-receipt/${items?.ID}`
                                  }
                                  target="_blank"
                                >
                                  Receipt
                                </Link>
                              </td>
                              <td className="col-md-3">
                                {model === "employee"
                                  ? items?.Comments
                                  : items?.Memo}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Tab>

            {model !== "employee" && (
              <Tab
                eventKey="tab2"
                title={
                  model === "customer"
                    ? "Receive Payment"
                    : model === "supplier"
                    ? "PayBill"
                    : "Employee"
                }
              >
                <div className="row">
                  <div className="col-md-12 p-3">
                    <div className="table-responsive">
                      <table className="table mb-0 table-border ">
                        <thead>
                          <tr>
                            <th>Tran Id</th>
                            <th>Created Date</th>
                            <th>Method</th>
                            <th>Account</th>
                            <th>Amount</th>
                            <th>Comment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(model === "customer"
                            ? dataReceivePaymentList
                            : model === "supplier"
                            ? dataPayBillList
                            : []
                          )?.map((items, index) => {
                            return (
                              <tr key={index}>
                                <td className="col-md-2 cursor-pointer" style={{ textDecoration: "underline" }} onClick={() => handlePaymentClick(items?.ID)}>{items?.ID}</td>
                                <td className="col-md-2">
                                  {moment(items?.LatestDate)?.format(
                                    "MM/DD/YYYY h:mm A"
                                  )}
                                </td>
                                <td className="col-md-2">
                                  {items?.PaymentType}
                                </td>
                                <td className="col-md-2">
                                  {items?.Account}
                                </td>
                                <td className="col-md-2">
                                  {CurrencySymbols(
                                    Number(items?.Payment),
                                    CurrencySymbol,
                                    FractionDigits
                                  )}
                                  {/* {`$${Number(items?.Payment).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}`} */}
                                  {/* {parseInt(items?.Payment).toFixed(2)} */}
                                </td>
                                <td className="col-md-2">{items?.Memo}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Tab>
            )}

            <Tab
              eventKey="tab3"
              title={
                model === "customer"
                  ? "Customer Details"
                  : model === "supplier"
                  ? "Supplier Details"
                  : "Employee Details"
              }
            >
              <div className="row">
                <div className="col-md-12 p-3">
                  <div className="table-responsive">
                    <table className=" custom-bordered-table">
                      <tbody>
                        {[
                          ...(model !== "employee"
                            ? [
                                {
                                  label: "Company Name",
                                  value:
                                    details?.CompanyName + ` [${details?.Id}]`,
                                },
                              ]
                            : [
                                {
                                  label: "Employee Role",
                                  value: details?.EmployeeRole,
                                },
                              ]),

                          {
                            label: "Name",
                            value: `${details?.FirstName} ${
                              details?.LastName
                            } ${
                              model == "employee" ? "[" + details.Id + "]" : ""
                            }`,
                          },
                          { label: "E-Mail", value: details?.Email },
                          {
                            label: "Phone Number",
                            value: details?.PhoneNumber,
                          },
                          // {
                          //   label: "Address",
                          //   value: `${details?.Address1} ${details?.Address2}, ${details?.City}, ${details?.StateProvince} ${details?.Zip}, ${details?.Country}`,
                          //   // value: `${details?.Address1} ${details?.Address2} ${details?.City} ${details?.StateProvince} ${details?.Zip} ${details?.Country}`,
                          // },
                          {
                            label: "Address",
                            value: [
                              details?.Address1,
                              details?.Address2,
                              details?.City,
                              details?.StateProvince + " " + details?.Zip,
                              details?.Country,
                            ]
                              .filter(Boolean)
                              .join(", "),
                          },
                          {
                            label: "Comments",
                            value: details?.Comments,
                          },
                          ...(model === "customer"
                            ? [
                                {
                                  label:
                                    "Message to show when adding customer to sale",
                                  value:
                                    details?.MessageToShowWhenAddingCustomerToSales,
                                },
                                {
                                  label: "Role Tier",
                                  value: details?.RoleTierName,
                                },
                                {
                                  label: "ROUTE",
                                  value: details?.Route,
                                },
                                {
                                  label: "LEVEL",
                                  value: details?.LEVEL,
                                },
                                { label: "REP", value: details?.REP },
                              ]
                            : []),

                          ...(model !== "employee"
                            ? [
                                {
                                  label: "Internal Notes",
                                  value: details?.InternalNotes,
                                },
                                {
                                  label: "Account #",
                                  value: details?.AccountNumber,
                                },
                                {
                                  label: "Open Balance",
                                  value: balanceLading ? (
                                  <img
                                    src={loadingimage}
                                    alt="Loading..."
                                    width={20}
                                    className="ms-1"
                                    style={{
                                      display: "inline-block",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                ) : ( showCustomerBalance ?
                                   CurrencySymbols(
                                    Number(customerBalance),
                                    { CurrencySymbol },
                                    FractionDigits
                                  )
                                  : (<span style={{ fontSize: "12px", cursor:'pointer', textDecoration: "underline" }} onClick={()=> checkBalance(id)}>
                                      Click Here
                                    </span>)
                                )
                                },
                              ]
                            : []),
                        ].map((row, index) => (
                          <tr key={index}>
                            <td>{row.label}</td>
                            <td>{row.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Tab>

            {model === "customer" &&
              checkUserPermission(PERMISSION_PASSWORD) && (
                <Tab eventKey="tab4" title="Ecom Login">
                  <div className="row">
                    <div className="col-md-12 p-3">
                      {isecom ? (
                        <div className="container d-flex justify-content-center mt-3">
                          <div className="row col-md-8">
                            <p className="p-lg mb-4 ">Ecom customer Login</p>

                            {/* Email Input */}
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <label className="col-form-label form-label">
                                  Email
                                </label>
                              </div>
                              <div className="col-md-5">
                                <input
                                  type="email"
                                  className="form-control form-control-sm"
                                  onChange={(e) => emailChange(e)}
                                  value={usernamePass.Email}
                                  id="Email"
                                  name="Email"
                                />
                              </div>
                            </div>

                            {/* Username Input */}
                            <div className="row mb-2">
                              <div className="col-md-4">
                                <label className="col-form-label form-label">
                                  Username
                                </label>
                              </div>
                              <div className="col-md-5">
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  // onChange={(e) => userNameChange(e)}
                                  value={usernamePass.Uname}
                                  id="Username"
                                  name="Username"
                                  readOnly
                                />
                              </div>
                            </div>

                            {/* Current Password Input (conditionally displayed) */}
                            {id > 0 && passworddeable === 1 && (
                              <div className="row mb-2">
                                <div className="col-md-4">
                                  <label className="col-form-label form-label">
                                    Current Password
                                  </label>
                                </div>
                                <div className="pass-group col-md-5">
                                  {/* <div className="pass-group"> */}
                                  <input
                                    type={eyePass ? "password" : "text"}
                                    className="form-control form-control-sm"
                                    value={usernamePass?.OriginalPassword}
                                    id="Password"
                                    name="Password"
                                    readOnly
                                    // onClick={onEyePassClick}
                                  />
                                  <span
                                    className={`fas toggle-password ${
                                      eyePass ? "fa-eye-slash" : "fa-eye"
                                    }`}
                                    onClick={onEyePassClick}
                                    style={{ cursor: "pointer" }}
                                  />
                                  {/* </div> */}
                                </div>
                                <div
                                  className="btn btn-dark col-md-5"
                                  onClick={() =>
                                    setChnagePassword(
                                      changePassword ? false : true
                                    )
                                  }
                                  style={{ width: "155px" }}
                                >
                                  {" "}
                                  Change Password
                                </div>
                              </div>
                            )}

                            {/* New Password Input */}
                            {changePassword ? (
                              <>
                                <div className="row mb-2">
                                  <div className="col-md-4">
                                    <label className="col-form-label form-label">
                                      New Password
                                    </label>
                                  </div>
                                  <div className="pass-group col-md-5">
                                    <input
                                      type={eyeNew ? "password" : "text"}
                                      // name="NewPassword"
                                      placeholder="Enter New Password"
                                      autoComplete="new-password"
                                      className="form-control form-control-sm"
                                      onChange={(e) =>
                                        setUsernamePass({
                                          ...usernamePass,
                                          Pass: e.target.value,
                                        })
                                      }
                                      value={usernamePass?.Pass || ""}
                                    />
                                    <span
                                      onClick={onEyeNewClick}
                                      className={`fas toggle-password ${
                                        eyeNew ? "fa-eye-slash" : "fa-eye"
                                      } `}
                                    />
                                  </div>
                                </div>

                                {/* Confirm Password Input */}
                                <div className="row mb-2">
                                  <div className="col-md-4">
                                    <label className="col-form-label form-label">
                                      Confirm Password
                                    </label>
                                  </div>
                                  <div className="pass-group col-md-5">
                                    <input
                                      type={eyeConfirm ? "password" : "text"}
                                      autoComplete="new-password"
                                      placeholder="Enter Confirm Password"
                                      className="form-control form-control-sm"
                                      onChange={(e) =>
                                        setUsernamePass({
                                          ...usernamePass,
                                          ConfirmPass: e.target.value,
                                        })
                                      }
                                      value={usernamePass?.ConfirmPass || ""}
                                    />
                                    <span
                                      onClick={onEyeConfirmClick}
                                      className={`fas toggle-password ${
                                        eyeConfirm ? "fa-eye-slash" : "fa-eye"
                                      } `}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {/* Buttons */}
                            <div className="d-flex justify-content-start">
                              <button
                                type="submit"
                                className="btn btn-primary btn-md me-2 mt-4"
                                onClick={() =>
                                  handleSubmit(
                                    usernamePass.Uname,
                                    usernamePass?.Pass,
                                    usernamePass?.ConfirmPass,
                                    usernamePass?.Email
                                  )
                                }
                              >
                                Save
                              </button>
                              {usernamePass?.Email && (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-md me-1 mt-4"
                                  onClick={() =>
                                    handleSendEmail(
                                      usernamePass.Uname,
                                      usernamePass?.Pass,
                                      usernamePass?.ConfirmPass,
                                      usernamePass?.Email
                                    )
                                  }
                                >
                                  {/* Resend Password */}
                                  {usernamePass?.ConfirmPass === "" ? "Resend Password" : "Save & Resend Password"}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Tab>
              )}

            {model === "customer" && (
              <Tab eventKey="tab5" title="Ecom User Login History">
                <div className="row">
                  <div className="col-md-12 p-3">
                    <div className="table-responsive">
                      <table className="table mb-0 table-border ">
                        <thead>
                          <tr>
                            <th>Login Time</th>
                            <th>DeviceType</th>
                            <th>IpAddress</th>
                            <th>Address</th>
                            {/* <th>Map Address</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {loginDetails?.map((items, index) => {
                            return (
                              <tr key={index}>
                                <td className="col-md-3">
                                  {/* {loginDetails?.LoginDateTime} */}
                                  {moment(items?.LoginDateTime)?.format(
                                    "MM/DD/YYYY h:mm A"
                                  )}
                                </td>
                                <td className="col-md-3">
                                  {items?.DeviceType}
                                </td>
                                <td className="col-md-3">{items?.IpAddress}</td>
                                <td className="col-md-3">
                                  {/* {items?.country},{items?.region},
                                        {items?.city},{items?.zip} */}
                                  {items?.ipAddressLocation}
                                </td>
                                {/* <td className="col-md-3">
                                        <button
                                          onClick={() => handleNavigate(items)}
                                        >
                                          Open in Google Maps
                                        </button>
                                      </td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Tab>
            )}

            {model === "customer" && (
              <Tab eventKey="tab6" title="Address Book">
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="col-md-10"> </div>

                  <div className=" col-md-2  ms-auto">
                    <button
                      type="button"
                      onClick={handleclicks}
                      className="btn btn-primary "
                    >
                      Add Shipping Address
                    </button>
                  </div>
                </div>

                <div class=" mt-3 mb-3">
                  <table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                    }}
                  >
                    <thead>
                      <tr>
                        <th className="thStyle"> sr.No </th>
                        <th className="thStyle">Address1</th>
                        <th className="thStyle">Address2</th>
                        <th className="thStyle">City</th>
                        <th className="thStyle">State/Province</th>
                        <th className="thStyle">Country</th>
                        <th className="thStyle">Zip</th>
                        <th className="thStyle"> Created By </th>
                        <th className="thStyle">Is Shipping Default</th>
                        <th className="thStyle">Address Type</th>
                        <th className="thStyle">Edit</th>
                        <th className="thStyle">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerAddressBookList.map((item, index) => (
                        <tr key={index}>
                          <td className="tdStyle">{index + 1}</td>
                          <td className="tdStyle">{item.Address1}</td>
                          <td className="tdStyle">{item.Address2}</td>
                          <td className="tdStyle">{item.City}</td>
                          <td className="tdStyle">{item.StateProvince}</td>
                          <td className="tdStyle">{item.Country}</td>
                          <td className="tdStyle">{item.Zip}</td>
                          <td className="tdStyle"> {item?.CreatedFrom}</td>
                          <td className="tdStyle">
                            {item.ID === yesID ? "Yes" : "No"}
                          </td>
                          <td className="tdStyle">
                            {item.IsDefault == 0 ? "Shipping" : "Billing"}
                          </td>
                          <td className="tdStyle">
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled={item.IsDefault == 0 ? false : true}
                              onClick={() => {
                                setAddressEdit(item);
                                setOpen(true);
                              }}
                            >
                              {" "}
                              Edit{" "}
                            </button>
                          </td>
                          <td className="tdStyle">
                            <button
                              className="btn btn-primary"
                              type="button"
                              disabled={item.IsDefault == 0 ? false : true}
                              onClick={() => handleDeleteAddress(item)}
                            >
                              {" "}
                              Delete{" "}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Tab>
            )}
          </Tabs>
        </Modal.Body>
      </Modal>
      <AddressModal
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        AddressEdit={AddressEdit}
        ID={id}
      />
    </>
  );
};

export default CustomerSupplierDetailModel;
